import { StateCreator } from "zustand";

export interface ConversationSlice {
  id: string;
  setId: (id: string) => void;
}

const createConversationSlice: StateCreator<
  ConversationSlice,
  [],
  [],
  ConversationSlice
> = (set) => ({
  id: "",
  setId: (id: string) => set(() => ({ id })),
});

export default createConversationSlice;
